export const getResourcesList = async function (param) {
    const requestURL = "/resources/web/list";
    const requestParam = param;

    const response = await o2.util.Http.requestData(requestURL, requestParam, {parameterType: "json"});

    return response;
};

export const getResources = async function (resourcesId) {
    const requestURL = `/resources/${resourcesId}`;
    const requestParam = {};

    const response = await o2.util.Http.requestData(requestURL, requestParam, {method: "GET"});

    return response;
};

export const getFeaturedResource = async function () {
    const requestURL = "/resources/web/featured";
    const requestParam = {};

    const response = await o2.util.Http.requestData(requestURL, requestParam, {method: "GET"});

    return response;
};
